import React, { useRef } from "react";
import { Navbar } from "react-bootstrap";
import ButtonToolbar from "react-bootstrap/ButtonToolbar";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Popover from "react-bootstrap/Popover";
import { useMediaQuery } from "react-responsive";
import styled from "styled-components";
import { labels } from "../../../../localization/labels";
import Breadcrumbs from "../../../core/Breadcrumbs";
import SubmitButton from "../../../core/SubmitButton";
import UpdatingPopover from "../../../core/UpdatingPopover";
import NotificationBadge from "../NotificationBadge";
import Settings from "../Settings";
import Help from "../Help";
import { faUser } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const Body = styled.div`
  @media (max-width: 767px) {
    margin-left: 80px;
  }
`;

const TopBar = props => {
  const party = props.party;

  const [show, setShow] = React.useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const bodyRef = useRef(null);

  const isSmall = useMediaQuery({
    query: "(max-width: 767px)"
  });
  const containerRef = isSmall ? bodyRef : document.body;

  return (
    <Body ref={bodyRef}>
      {party != null && (
        <Navbar bg="topBar" className="justify-content-between">
          <Breadcrumbs
            ref={props.breadcrumbsRef}
            onClick={props.onBreadcrumbClick}
            onHomeMenuClick={props.onHomeMenuClick}
          />
          <ButtonToolbar>
            <Help
              messageHandler={props.messageHandler}
              breadcrumbsHandler={props.breadcrumbsHandler}
            />
            <NotificationBadge
              messageHandler={props.messageHandler}
              breadcrumbsHandler={props.breadcrumbsHandler}
              containerRef={containerRef}
              notificationBadgeRefreshPropagator={
                props.notificationBadgeRefreshPropagator
              }
            />
            <OverlayTrigger
              trigger="click"
              placement={"bottom"}
              container={containerRef?.current}
              opacity="1"
              rootClose
              overlay={
                <UpdatingPopover id={`party-popover`}>
                  <Popover.Title as="h3">
                    <div className="settings">
                      <div className="btnUserSettings">
                        <FontAwesomeIcon
                          icon={faUser}
                          roundedCircle
                          title={party.username}
                        />
                      </div>
                      <div>{party.username}</div>
                    </div>
                  </Popover.Title>
                  <Popover.Content>
                    <div className="d-flex ">
                      <div>
                        <SubmitButton
                          onClick={props.onLogout}
                          text={labels.logout}
                          className="buttonStyle"
                        />
                      </div>
                      <div className="ml-auto">
                        <SubmitButton
                          type="settings"
                          transparent
                          onClick={event => {
                            event.preventDefault();
                            document.body.click();
                            handleShow();
                          }}
                        />
                      </div>
                    </div>
                  </Popover.Content>
                </UpdatingPopover>
              }
            >
              <div className="btnUser">
                <FontAwesomeIcon
                  icon={faUser}
                  roundedCircle
                  className="btnInfoHover"
                  title={party.username}
                />
              </div>
            </OverlayTrigger>
          </ButtonToolbar>
          <Settings
            show={show}
            handleClose={handleClose}
            messageHandler={props.messageHandler}
            breadcrumbsHandler={props.breadcrumbsHandler}
          />
        </Navbar>
      )}
    </Body>
  );
};

export default TopBar;
